// extracted by mini-css-extract-plugin
export default {"dateContainer":"DateMessage__dateContainer___NAl0U","dateV2":"DateMessage__dateV2___Q4T8D","border":"DateMessage__border___wOsHg"};